import { useContext } from 'react';
import { WatchlistContext } from '@pkgs/components/providers/WatchlistProvider';

export function useWatchlist() {
  const ctx = useContext(WatchlistContext);

  if (ctx === undefined) {
    throw new Error('useWatchlist used outside of ContextProvider!');
  }

  return ctx;
}
